import React from 'react';
import { bio } from '../mock';

const About = () => {
  return (
    <div className="min-h-screen bg-off-white py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Image */}
          <div className="relative aspect-[3/4] bg-warm-grey rounded-lg overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_art-study-space/artifacts/wnulyfhe_Queen%20Mother%20and%20Priestess%20Crowns.png"
              alt="Asia B. Jewell with Queen Mother and Priestess Crowns"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Bio Content */}
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
                {bio.name}
              </h1>
              <p className="text-xl text-burgundy font-medium mb-2">
                {bio.identity}
              </p>
              <p className="text-lg text-neutral-600">
                {bio.education}
              </p>
            </div>

            <div className="prose prose-lg">
              <p className="text-neutral-700 leading-relaxed">
                {bio.description}
              </p>
            </div>

            {/* Practice Areas */}
            <div className="border-t border-neutral-300 pt-8">
              <h3 className="text-xl font-semibold text-charcoal mb-4">Practice Areas</h3>
              <div className="flex flex-wrap gap-3">
                <span className="bg-copper text-charcoal px-4 py-2 rounded-full text-sm font-medium">
                  Performance Art
                </span>
                <span className="bg-copper text-charcoal px-4 py-2 rounded-full text-sm font-medium">
                  Video Art
                </span>
                <span className="bg-copper text-charcoal px-4 py-2 rounded-full text-sm font-medium">
                  Digital Fabrication
                </span>
                <span className="bg-copper text-charcoal px-4 py-2 rounded-full text-sm font-medium">
                  Spoken Word
                </span>
                <span className="bg-copper text-charcoal px-4 py-2 rounded-full text-sm font-medium">
                  Material Work
                </span>
                <span className="bg-copper text-charcoal px-4 py-2 rounded-full text-sm font-medium">
                  Mixed Media
                </span>
              </div>
            </div>

            {/* Current Work */}
            <div className="bg-warm-grey p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-charcoal mb-3">Current Affiliations</h3>
              <ul className="space-y-2 text-neutral-700">
                <li className="flex items-start">
                  <span className="text-copper mr-2">•</span>
                  Filson Historical Society
                </li>
                <li className="flex items-start">
                  <span className="text-copper mr-2">•</span>
                  Kentucky College of Art + Design (KyCAD)
                </li>
                <li className="flex items-start">
                  <span className="text-copper mr-2">•</span>
                  Roots 101 African American Museum
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;